var _path, _path2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOutlineIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M7 8h2v12H7z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M7 13v-2h7v2zM7 20v-2h7v2z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 5,
  r: 2,
  fill: "#000"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 12,
  r: 2,
  fill: "#000"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 19,
  r: 2,
  fill: "#000"
})));
export { SvgOutlineIcon as ReactComponent };
export default __webpack_public_path__ + "9dfe37b90356a29833e6f62bf8c71dc1.svg";